export default __webpack_public_path__ + "static/media/logo1 (1).ceeb58b0.png";